import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';

export const unknown = {
  id: 'UNKNOWN',
  apiKey: 'unknown',
  component: <FormattedMessage {...messages.unknown} />,
};

export const inTransit = {
  id: 'INTRANSIT',
  apiKey: 'inTransit',
  component: <FormattedMessage {...messages.inTransit} />,
};

export const delivered = {
  id: 'DELIVERED',
  apiKey: 'delivered',
  component: <FormattedMessage {...messages.delivered} />,
};

export const undeliverable = {
  id: 'UNDELIVERABLE',
  apiKey: 'failed',
  component: <FormattedMessage {...messages.undeliverable} />,
};

export const deliveryStatusOptions = [unknown, inTransit, delivered, undeliverable];
